import { Injectable } from '@angular/core';
import {AngularFireAuth} from 'angularfire2/auth';

import * as firebase from 'firebase/app';
import {Observable} from 'rxjs/Rx';
import {Router} from '@angular/router';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class AuthService {
  private user: Observable<firebase.User>;
  private currentUser: Observable<firebase.User>;

  private userType: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  constructor(private afAuth: AngularFireAuth, private router: Router) {
    this.user = afAuth.authState;
    this.currentUser = afAuth.authState;
    this.user.subscribe( user => {
      if (user) {
        user.getIdToken().then((idToken) => {
          // Parse the ID token.
          const payload = JSON.parse(atob(idToken.split('.')[1]));
          // Confirm the user is an Admin.
          if (!!payload['admin']) {
            this.userType.next('admin');
          } else if (!!payload['partner']) {
            this.userType.next('partner');
          } else {
            this.userType.next('client');
          }
          console.log('userType', this.userType, payload);
        }).catch((error) => console.log('err', error));
      } else {
        this.userType.next(null);
      }
    }, err => console.log(err));
  }
  getCurrentUser(): Observable<firebase.User> {
    return this.currentUser;
  }
  signIn(email: string, password: string): Promise<any> {
    return this.afAuth.auth.signInWithEmailAndPassword(email, password);
  }
  signOut() {
    this.afAuth.auth.signOut().then(() => {window.location.href = '/'; });
  }
  googleLogin() {
    const provider = new firebase.auth.GoogleAuthProvider()
    provider.addScope('profile');
    provider.addScope('email');
    return this.socialSignIn(provider)
  }

  githubLogin() {
    const provider = new firebase.auth.GithubAuthProvider();
    return this.socialSignIn(provider);
  }

  facebookLogin() {
    const provider = new firebase.auth.FacebookAuthProvider();
    provider.addScope('public_profile ');
    provider.addScope('email ');
    return this.socialSignIn(provider)
  }

  twitterLogin() {
    const provider = new firebase.auth.TwitterAuthProvider()
    return this.socialSignIn(provider);
  }

  private socialSignIn(provider) {
    // this.afAuth.auth.languageCode = 'fr_FR'; Mudar linguagem;

    return this.afAuth.auth.signInWithPopup(provider);
  }
  registerUser(email, password) {
    return this.afAuth.auth.createUserWithEmailAndPassword(email, password);
  }
  sendVerifyEmail() {
    return this.afAuth.auth.currentUser.sendEmailVerification()
  }
  sendRecoveryEmail(email: string) {
    return this.afAuth.auth.sendPasswordResetEmail(email);
  }
  deleteAccount() {
    return this.afAuth.auth.currentUser.delete();
  }
  verifyEmail(actionCode: string, apiKey: string) {
    return this.afAuth.auth.applyActionCode(actionCode);
  }
  reloadUser() {
    if (this.afAuth.auth !== null) {
      if (this.afAuth.auth.currentUser !== null) {
        return this.afAuth.auth.currentUser.reload();
      }
    } else {
      return Promise.reject('No User');
    }

  }
  fetchProvidersForEmail(email: string) {
    return this.afAuth.auth.fetchProvidersForEmail(email);
  }
  
  linkAccount(credential: any) {
    return this.afAuth.auth.currentUser.linkWithCredential(credential);
  }
  getEmailCredential(email: string, password: string) {
    return firebase.auth.EmailAuthProvider.credential(email, password);
  }
  verifyPasswordResetCode(code: string) {
    return this.afAuth.auth.verifyPasswordResetCode(code);
  }
  confirmPasswordReset(code: string, password: string) {
    return this.afAuth.auth.confirmPasswordReset(code, password);
  }
  validateEmail() {
  }
 getUserType() {
    return this.userType;
 }
}



// WEBPACK FOOTER //
// C:/Users/bruna/Desktop/nuresp/src/app/shared/services/auth.service.ts